var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5831 0.292909C2.19258 -0.0976242 1.55942 -0.097638 1.16889 0.292878C0.778352 0.683393 0.778339 1.31656 1.16885 1.70709L3.16193 3.70025L1.16905 5.69322C0.778529 6.08375 0.778543 6.71692 1.16908 7.10743C1.55961 7.49795 2.19277 7.49794 2.58329 7.1074L4.57611 5.1145L6.56893 7.1074C6.95945 7.49794 7.59261 7.49795 7.98314 7.10743C8.37368 6.71692 8.37369 6.08375 7.98318 5.69322L5.99029 3.70025L7.98337 1.70709C8.37388 1.31656 8.37387 0.683393 7.98334 0.292878C7.5928 -0.097638 6.95964 -0.0976242 6.56912 0.292909L4.57611 2.28601L2.5831 0.292909Z",
    fill: "#3D576B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.dbbb1fe68262c295c72feed37652ee6f.svg";
export { ForwardRef as ReactComponent };